import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const MEGAMARKET_FAQ = [
  {
    title: "Что такое Boostclick?",
    isH3: false,
    text:
      <p>
        Boostclick — это платформа для размещения микрозаданий.
        <br />
        Вы создаете задания с описанием действий на маркетплейсах, а пользователи выполняют их и присылают отчеты.
      </p>
  },
  {
    title: "Можно ли использовать Boostclick для продвижения на Мегамаркете*?",
    isH3: false,
    text:
      <p>
        Да. Сервис позволяет организовать взаимодействие пользователей с карточками товаров. Все действия исполняются вручную.
      </p>
  },
  {
    title: "Что входит в сценарий?",
    isH3: false,
    text:
      <div>
        Вы можете указать:
        <br />
        <br />
        <ul>
          <li>Найти товар по фразе</li>
          <li>Перейти по ссылке</li>
          <li>Посмотреть изображение или описание</li>
          <li>Добавить товар в корзину или избранное</li>
        </ul>
      </div>
  },
  {
    title: "Вы делаете «накрутку?»",
    isH3: false,
    text:
      <p>
        Нет.
        <br />
        <br />
        Boostclick не оказывает услуг по накрутке и не гарантирует влияние на внутренние алгоритмы маркетплейсов.
        <br />
        Мы предоставляем платформу, где пользователи взаимодействуют с товарными карточками по индивидуальным сценариям и дают обратную связь заказчикам.
        <br />
        <br />
        Фраза «накрутка» используется исключительно в информационных целях, так как именно так пользователи могут формулировать свои запросы.
      </p>
  },
  {
    title: "Что такое ПФ?",
    isH3: false,
    text:
      <p>
        Под ПФ (поведенческими факторами) пользователи могут подразумевать различные сценарии взаимодействия с карточкой товара.
        <br />
        Boostclick не анализирует и не интерпретирует алгоритмы платформ. Мы лишь обеспечиваем инструмент для организации пользовательской активности.
      </p>
  },
  {
    title: "Какие гарантии?",
    isH3: false,
    text:
      <p>
        Сервис гарантирует, что задания будут выполнены вручную и в указанный срок. Отчеты можно проверять, при необходимости отправлять на доработку.
        <br />
        Все задания исполняются по договору-оферте, размещенному на сайте.
      </p>
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const REVIEW_PRICE = 250;

const ACTIONS = [
  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.5,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.2,
    activityType: 'Корзина',
  },
  {
    type: "MAIN.LIKE",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить лайк на последний отзыв",
    initialShare: 0.2,
    activityType: 'Лайк',
  },

  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение Мегамаркет",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар через поиск Мегамаркет",
    initialShare: 1,
  },
  {
    type: 'ALWAYS.COMPETITORS',
    icon: "time",
    iconHome: "home-time",
    title: 'Быстро посмотреть конкурентов',
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1,
  },

  {
    type: "EXTRA.MEDIA",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть все фото и видео на карточке",
    initialShare: 0.5,
  },
  {
    type: "EXTRA.DESCRIPTION",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать полное описание товара",
    initialShare: 0.2,
  },
  {
    type: "EXTRA.SPECS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Нажать «Все характеристики»",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.GOODS",
    icon: "click",
    iconHome: "home-click",
    title: "Посмотреть другие товары продавца",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать отзывы на товар",
    initialShare: 0.1,
  },

  {
    type: "MAIN.THUMBSUP",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить палец вверх на последний вопрос о товаре",
    initialShare: 0.1,
    activityType: 'Лайк',
  },
  {
    type: "MAIN.DISLIKE",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Поставить дизлайк на последний отзыв",
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    titleComment: "Изучение товаров",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-heart",
    title: "В избранное",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "В корзину",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "Купить сейчас",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Оценить отзыв",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть сайт или приложение",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-time",
    title: "Посмотреть конкурентов",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-megamarket",
    target: '_self',
  }
];

const STEP_PHRASE_2 = "Укажите информацию для поиска товара";

const MEGAMARKET_KEYWORDS = [
  'Mega', 'Megamarket', 'mega', 'megamarket', 'Мега', 'Мегамаркет', 'мегамаркет', 'мега'
];

class MegamarketClass extends Market {
  id = "megamarket";
  host = "megamarket.ru";
  url = "https://megamarket.ru/";

  title = "Мегамаркет";

  isMarketplace = true;

  icon = "megamarket";
  titlePlaces = "Мегамаркет";
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: "Супермаркет" },
    { type: "Товары для дома" },
    { type: "Красота и уход" },
    { type: "Детские товары" },
    { type: "Электроника" },
    { type: "Бытовая техника" },
    { type: "Книги, хобби, канцелярия" },
    { type: "Одежда, обувь и аксессуары" },
    { type: "Продукты питания" },
    { type: "Здоровье" },
    { type: "Автотовары" },
    { type: "Зоотовары" },
    { type: "Мебель" },
    { type: "Строительство и ремонт" },
    { type: "Спорт и активный отдых" },
    { type: "Уборка и гигиена" },
    { type: "Дача, сезонные товары" },
    { type: "Ювелирные изделия" },
    { type: "Услуги и цифровые товары" },
    { type: "Товары для геймеров" },
    { type: "Автомобили и мототехника" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = MEGAMARKET_KEYWORDS;

  targetLinkComment = "Укажите тут адрес вашего товара на Мегамаркете";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-megamarket",
      rating: 0.68,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: "Продвижение ПФ ЛЮДИ на Мегамаркете — просмотры, лайки",
        description: "Повышение ПФ ЛЮДИ на Мегамаркете — просмотры, добавления.",
        canonical: '/povedencheskie-faktory-na-megamarket',
      },
      intro: {
        title: "Продвижение на Мегамаркете* через действия реальных пользователей",
        comment: 'Настройка пользовательских сценариев и микрозадач',
        points: [
          'Без использования ботов',
          'Без самовыкупов',
          'Уникальные пользователи для каждого задания',
          'Сроки исполнения соблюдаются',
          'Детализированные отчеты',
          'Поиск магазина по заданным ключевым фразам',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите категорию, город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройка пользовательских сценариев",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Организация пользовательской активности на Мегамаркете*",
      titleFAQ: "Вопрос-ответ о накрутке Мегамаркет",
      faq: MEGAMARKET_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        '*Сервис формирует цепочки пользовательских действий по сценарию.',
        <p>
          Каждому исполнителю назначается индивидуальное задание, которое может включать:
          <br />
          – Поиск карточки по ключевой фразе
          <br />
          – Просмотр описания и изображений
          <br />
          – Добавление в избранное или корзину
        </p>,
        'Параметры сценариев настраиваются в зависимости от проекта. Все действия выполняются вручную.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на товар';
  invalidUrlStr = 'Укажите корректную ссылку на товар';
}

const Megamarket = new MegamarketClass();
export default Megamarket;
